import request from "@/utils/request";


// 关于我们相关的接口
export function aboutList() {
  return request.post('/home/getAboutUs')
}

// 需要首页的接口
export function addressList() {
  return request.post('/home/getHomeInfo')
}


